import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var generateStyle = function generateStyle(componentTheme, props) {
  var printMq = '@media print';
  var isScrollable = props.sidebarComponent != null && props.sidebarOpen != null;
  return {
    wrapper: _defineProperty({
      display: 'flex',
      fontFamily: componentTheme.fontFamily,
      height: '100%',
      margin: '0'
    }, printMq, {
      display: 'block'
    }),
    childrenWrapper: _objectSpread(_objectSpread({}, isScrollable && {
      overflowX: 'hidden',
      overflowY: 'auto'
    }), {}, {
      transition: componentTheme.contentTransition,
      width: '100%',
      '.user_content p': {
        margin: "".concat(componentTheme.userContentMargin, " 0"),
        '&:first-of-type': {
          margin: "0 0 ".concat(componentTheme.userContentMargin)
        },
        '&:last-of-type': {
          margin: "".concat(componentTheme.userContentMargin, " 0 0")
        },
        '&:only-child': {
          margin: 0
        }
      }
    })
  };
};
export default generateStyle;